import React from 'react';
import Grid from '@material-ui/core/Grid';

const MyItemsSkeleton = () => {
    return (<Grid className='my-items' container spacing={0}>
        <Grid item xs={12}>
            <div className='my-items-skeleton'>
                <div className='my-items-skeleton-item'>
                    <i className='my-items-skeleton-icon'/>
                    <div>
                        <i className='my-items-skeleton-title one'/>
                        <i className='my-items-skeleton-title-main one'/>
                    </div>
                    <div>
                        <i className='my-items-skeleton-title-button big'/>
                    </div>
                </div>
                <div className='my-items-skeleton-item'>
                    <i className='my-items-skeleton-icon'/>
                    <div>
                        <i className='my-items-skeleton-title two'/>
                        <i className='my-items-skeleton-title-main two'/>
                        <i className='my-items-skeleton-title-main two-two'/>
                    </div>
                    <div>
                        <i className='my-items-skeleton-title-button thin two-two-two'/>
                    </div>
                </div>
                <div className='my-items-skeleton-item'>
                    <i className='my-items-skeleton-icon'/>
                    <div>
                        <i className='my-items-skeleton-title three'/>
                        <i className='my-items-skeleton-title-main three'/>
                    </div>
                    <div>
                        <i className='my-items-skeleton-title-button big'/>
                    </div>
                </div>
                <div className='my-items-skeleton-item'>
                    <i className='my-items-skeleton-icon'/>
                    <div>
                        <i className='my-items-skeleton-title two'/>
                        <i className='my-items-skeleton-title-main two'/>
                        <i className='my-items-skeleton-title-main two-two'/>
                    </div>
                    <div>
                        <i className='my-items-skeleton-title-button thin two-two-two'/>
                    </div>
                </div>
            </div>
        </Grid>
    </Grid>);
};

export default MyItemsSkeleton;
